// extracted by mini-css-extract-plugin
export var fullGrid = "_2t-3";
export var pdpPreviewContainer = "_2t-1";
export var previewContainer = "_2t-0";
export var togglePreviewContainer = "_2t-2";